import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'news', sv, true, true)
i18n.addResourceBundle('en', 'news', en, true, true)

export function buildNewsRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/news',
      component: lazyRouteComponent(
        () => import('./NewsPage'),
        'NewsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/news/$newsId',
      component: lazyRouteComponent(
        () => import('./NewsDetailPage'),
        'NewsDetailPage',
      ),
    }),
  ]
}
